import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import Translation from '../../../v2/lang/Translation';
import Spacing from '../../../v2/style-helper/Spacing';

const useStyles = createUseStyles({
  orderNumberWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  orderNumber: {
    fontWeight: 700,
    marginLeft: Spacing.half,
  },
});

export function OrderNumber(props) {
  const classes = useStyles();
  
  return (
    <div className={classes.orderNumberWrapper}>
      <Translation
        optionalExtension={props.siteCode}
      >
        checkout.complete.intro.order.number.text.updated
      </Translation>
      <p id="order-complete-id" className={classes.orderNumber}>
        {props.orderNumber}
      </p>
    </div>
  );
}

OrderNumber.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  siteCode: PropTypes.string.isRequired,
};

export default OrderNumber;
